import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { SearchInput } from '../components/ui/Input';
import { FileText, Download, Send, MoreHorizontal, CheckCircle, Loader2, Mail, X } from 'lucide-react';
const summaries = [{
  id: 'PDF-001',
  buyerId: 'User-8823',
  project: 'The Lawson',
  status: 'Sent',
  createdAt: '2 hours ago',
  sentAt: '2 hours ago'
}, {
  id: 'PDF-002',
  buyerId: 'User-7732',
  project: 'The Lawson',
  status: 'Pending',
  createdAt: '5 hours ago',
  sentAt: '-'
}, {
  id: 'PDF-003',
  buyerId: 'User-5519',
  project: 'The Lawson',
  status: 'Sent',
  createdAt: '1 day ago',
  sentAt: '1 day ago'
}, {
  id: 'PDF-004',
  buyerId: 'User-6621',
  project: 'The Samson',
  status: 'Sent',
  createdAt: '3 days ago',
  sentAt: '3 days ago'
}];
const availableBuyers = [{
  id: 'User-8823',
  model: 'The Lawson'
}, {
  id: 'User-7732',
  model: 'The Lawson'
}, {
  id: 'User-5519',
  model: 'The Lawson'
}, {
  id: 'User-6621',
  model: 'The Samson'
}];
export function PDFSummariesPage() {
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState('');
  const [selectedSummary, setSelectedSummary] = useState<any>(null);
  const [pdfStatus, setPDFStatus] = useState<'generating' | 'success'>('generating');
  const [sendStatus, setSendStatus] = useState<'sending' | 'success'>('sending');
  // ESC key handler
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (showGenerateModal) {
          handleCloseGenerateModal();
        }
        if (showSendModal) {
          handleCloseSendModal();
        }
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [showGenerateModal, showSendModal]);
  const handleGenerateNewPDF = () => {
    if (!selectedBuyer) return;
    setPDFStatus('generating');
    // Simulate PDF generation
    setTimeout(() => {
      setPDFStatus('success');
    }, 2000);
  };
  const handleSendPDF = (summary: any) => {
    setSelectedSummary(summary);
    setShowSendModal(true);
    setSendStatus('sending');
    // Simulate sending
    setTimeout(() => {
      setSendStatus('success');
    }, 1500);
  };
  const handleDownload = (summary: any) => {
    // Simulate download
    console.log('Downloading PDF:', summary.id);
    alert(`Downloading ${summary.id} - ${summary.buyerId} selections`);
  };
  const handleCloseGenerateModal = () => {
    setShowGenerateModal(false);
    setSelectedBuyer('');
    setPDFStatus('generating');
  };
  const handleCloseSendModal = () => {
    setShowSendModal(false);
    setSelectedSummary(null);
    setSendStatus('sending');
  };
  return <>
      <div className="space-y-6 max-w-7xl mx-auto" data-id="element-6485">
        <div className="flex items-center justify-between" data-id="element-6486">
          <div data-id="element-6487">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-6488">PDF Summaries</h1>
            <p className="text-slate-500" data-id="element-6489">
              Generated buyer selection summaries and exports.
            </p>
          </div>
          <Button leftIcon={<FileText className="h-4 w-4" data-id="element-6491" />} onClick={() => setShowGenerateModal(true)} data-id="element-6490">
            Generate New PDF
          </Button>
        </div>

        <Card noPadding data-id="element-6492">
          <div className="p-4 border-b border-slate-200 flex items-center justify-between bg-slate-50 rounded-t-xl" data-id="element-6493">
            <SearchInput className="max-w-sm bg-white" placeholder="Search by ID or buyer..." data-id="element-6494" />
            <div className="flex gap-2" data-id="element-6495">
              <Button variant="outline" size="sm" data-id="element-6496">
                Filter
              </Button>
              <Button variant="outline" size="sm" data-id="element-6497">
                Export All
              </Button>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-6498">
            <table className="w-full text-left text-sm" data-id="element-6499">
              <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-6500">
                <tr data-id="element-6501">
                  <th className="px-6 py-4" data-id="element-6502">PDF ID</th>
                  <th className="px-6 py-4" data-id="element-6503">Buyer ID</th>
                  <th className="px-6 py-4" data-id="element-6504">Project</th>
                  <th className="px-6 py-4" data-id="element-6505">Status</th>
                  <th className="px-6 py-4" data-id="element-6506">Created</th>
                  <th className="px-6 py-4" data-id="element-6507">Sent</th>
                  <th className="px-6 py-4 text-right" data-id="element-6508">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-6509">
                {summaries.map(summary => <tr key={summary.id} className="hover:bg-slate-50 transition-colors" data-id="element-6510">
                    <td className="px-6 py-4 font-medium text-slate-900" data-id="element-6511">
                      {summary.id}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-6512">
                      {summary.buyerId}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-6513">
                      {summary.project}
                    </td>
                    <td className="px-6 py-4" data-id="element-6514">
                      <Badge variant={summary.status === 'Sent' ? 'success' : 'warning'} data-id="element-6515">
                        {summary.status}
                      </Badge>
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-6516">
                      {summary.createdAt}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-6517">
                      {summary.sentAt}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-6518">
                      <div className="flex items-center justify-end gap-2" data-id="element-6519">
                        <Button variant="ghost" size="sm" leftIcon={<Download className="h-3 w-3" data-id="element-6521" />} onClick={() => handleDownload(summary)} data-id="element-6520">
                          Download
                        </Button>
                        {summary.status === 'Pending' && <Button variant="ghost" size="sm" leftIcon={<Send className="h-3 w-3" data-id="element-6523" />} onClick={() => handleSendPDF(summary)} data-id="element-6522">
                            Send
                          </Button>}
                        {summary.status === 'Sent' && <Button variant="ghost" size="sm" onClick={() => handleSendPDF(summary)} data-id="element-6524">
                            Resend
                          </Button>}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Generate New PDF Modal */}
      {showGenerateModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-6525">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-6526">
            {pdfStatus === 'generating' && !selectedBuyer ? <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-6527">
                  <div data-id="element-6528">
                    <h2 className="text-xl font-bold text-slate-900" data-id="element-6529">
                      Generate New PDF
                    </h2>
                    <p className="text-sm text-slate-500 mt-1" data-id="element-6530">
                      Select a buyer to generate their selection summary
                    </p>
                  </div>
                  <button onClick={handleCloseGenerateModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-6531">
                    <X className="h-5 w-5" data-id="element-6532" />
                  </button>
                </div>
                <div className="p-6" data-id="element-6533">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-6534">
                    Select Buyer
                  </label>
                  <select value={selectedBuyer} onChange={e => setSelectedBuyer(e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-6535">
                    <option value="" data-id="element-6536">Choose a buyer...</option>
                    {availableBuyers.map(buyer => <option key={buyer.id} value={buyer.id} data-id="element-6537">
                        {buyer.id} - {buyer.model}
                      </option>)}
                  </select>
                </div>
                <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-6538">
                  <Button variant="outline" onClick={handleCloseGenerateModal} data-id="element-6539">
                    Cancel
                  </Button>
                  <Button onClick={handleGenerateNewPDF} disabled={!selectedBuyer} data-id="element-6540">
                    Generate PDF
                  </Button>
                </div>
              </> : pdfStatus === 'generating' ? <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-6541">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-6542">
                    Generating PDF Summary
                  </h2>
                  <button onClick={handleCloseGenerateModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-6543">
                    <X className="h-5 w-5" data-id="element-6544" />
                  </button>
                </div>
                <div className="p-6 text-center" data-id="element-6545">
                  <div className="mx-auto w-16 h-16 bg-primary-50 rounded-full flex items-center justify-center mb-4" data-id="element-6546">
                    <Loader2 className="h-8 w-8 text-primary-600 animate-spin" data-id="element-6547" />
                  </div>
                  <p className="text-slate-500 text-sm mb-6" data-id="element-6548">
                    Creating selection summary for {selectedBuyer}...
                  </p>
                  <div className="space-y-2 text-left" data-id="element-6549">
                    <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-6550">
                      <CheckCircle className="h-4 w-4 text-green-600" data-id="element-6551" />
                      Collecting buyer selections
                    </div>
                    <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-6552">
                      <Loader2 className="h-4 w-4 text-primary-600 animate-spin" data-id="element-6553" />
                      Generating PDF document
                    </div>
                    <div className="flex items-center gap-3 text-sm text-slate-400" data-id="element-6554">
                      <div className="h-4 w-4 rounded-full border-2 border-slate-300" data-id="element-6555" />
                      Preparing email delivery
                    </div>
                  </div>
                </div>
              </> : <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-6556">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-6557">
                    PDF Generated Successfully
                  </h2>
                  <button onClick={handleCloseGenerateModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-6558">
                    <X className="h-5 w-5" data-id="element-6559" />
                  </button>
                </div>
                <div className="p-6" data-id="element-6560">
                  <div className="mx-auto w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4" data-id="element-6561">
                    <CheckCircle className="h-8 w-8 text-green-600" data-id="element-6562" />
                  </div>
                  <p className="text-slate-500 text-sm mb-6 text-center" data-id="element-6563">
                    Selection summary for {selectedBuyer} has been created and
                    sent to the buyer via email.
                  </p>
                  <div className="bg-slate-50 rounded-lg p-4 space-y-2 text-sm" data-id="element-6564">
                    <div className="flex justify-between" data-id="element-6565">
                      <span className="text-slate-600" data-id="element-6566">Buyer ID:</span>
                      <span className="font-medium text-slate-900" data-id="element-6567">
                        {selectedBuyer}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-6568">
                      <span className="text-slate-600" data-id="element-6569">PDF ID:</span>
                      <span className="font-medium text-slate-900" data-id="element-6570">
                        PDF-{String(summaries.length + 1).padStart(3, '0')}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-6571">
                      <span className="text-slate-600" data-id="element-6572">Status:</span>
                      <Badge variant="success" data-id="element-6573">Sent</Badge>
                    </div>
                  </div>
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-2" data-id="element-6574">
                    <Mail className="h-4 w-4 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-6575" />
                    <p className="text-xs text-blue-800" data-id="element-6576">
                      Email sent directly to buyer without exposing their email
                      address to your team.
                    </p>
                  </div>
                </div>
                <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-6577">
                  <Button onClick={handleCloseGenerateModal} data-id="element-6578">Done</Button>
                </div>
              </>}
          </div>
        </div>}

      {/* Send/Resend PDF Modal */}
      {showSendModal && selectedSummary && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-6579">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-6580">
            {sendStatus === 'sending' ? <>
                <div className="p-6 text-center" data-id="element-6581">
                  <div className="mx-auto w-16 h-16 bg-primary-50 rounded-full flex items-center justify-center mb-4" data-id="element-6582">
                    <Loader2 className="h-8 w-8 text-primary-600 animate-spin" data-id="element-6583" />
                  </div>
                  <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-6584">
                    Sending PDF
                  </h2>
                  <p className="text-slate-500 text-sm" data-id="element-6585">
                    Sending {selectedSummary.id} to {selectedSummary.buyerId}...
                  </p>
                </div>
              </> : <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-6586">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-6587">
                    Email Sent Successfully
                  </h2>
                  <button onClick={handleCloseSendModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-6588">
                    <X className="h-5 w-5" data-id="element-6589" />
                  </button>
                </div>
                <div className="p-6" data-id="element-6590">
                  <div className="mx-auto w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4" data-id="element-6591">
                    <CheckCircle className="h-8 w-8 text-green-600" data-id="element-6592" />
                  </div>
                  <p className="text-slate-500 text-sm mb-6 text-center" data-id="element-6593">
                    PDF summary has been sent to {selectedSummary.buyerId} via
                    email.
                  </p>
                  <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-2" data-id="element-6594">
                    <Mail className="h-4 w-4 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-6595" />
                    <p className="text-xs text-blue-800" data-id="element-6596">
                      Email sent directly to buyer without exposing their email
                      address to your team.
                    </p>
                  </div>
                </div>
                <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-6597">
                  <Button onClick={handleCloseSendModal} data-id="element-6598">Done</Button>
                </div>
              </>}
          </div>
        </div>}
    </>;
}